export default __webpack_public_path__ + "static/media/img-2.4e4a9a95.jpg";